import React, { useEffect, useState } from 'react';
import {
  Box,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Skeleton,
  Stack,
} from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { MultiStepForm, Step } from 'react-multi-form-custom-fix';
import BasicDetails from '../shared/basic-details';
import AboutUs from '../shared/about-us';
import AboutService from '../shared/about-service';
import ContactUs from '../shared/contact-us';
import SocialLinks from '../shared/social-links';
import Gallery from '../shared/gallery';
import { useDispatch } from 'react-redux';
import { deleteSite, setSite } from '../../../features/site/siteSlice';
import HeroSection from '../shared/hero-section';
import { getSite } from '../../../api/siteApi';

function EditSite() {
  const dispatch = useDispatch();
  const [step, setStep] = useState(1);
  const [showLoadingView, setShowLoadingView] = useState(false);

  useEffect(() => {
    fetchSite();
    return () => {
      dispatch(deleteSite());
    };
    // eslint-disable-next-line
  }, []);

  const nextClicked = () => {
    setStep(step + 1);
  };

  const prevClicked = () => {
    setStep(step - 1);
  };

  const fetchSite = () => {
    const id = new URLSearchParams(window.location.search).get('id');
    if (!id) {
      return;
    }

    getSite(id)
      .then(response => {
        if (response.site) {
          dispatch(setSite(response.site));
          setShowLoadingView(true);
        } else {
          console.log('Unable to load the site');
        }
      })
      .catch(error => {
        console.log(error);
      });
  };

  return (
    <>
      <Breadcrumb marginTop={2} marginLeft={2}>
        <BreadcrumbItem>
          <BreadcrumbLink as={Link} to="/">
            Home
          </BreadcrumbLink>
        </BreadcrumbItem>
        <BreadcrumbItem>
          <BreadcrumbLink as={Link} to="/sites">
            Sites
          </BreadcrumbLink>
        </BreadcrumbItem>
        <BreadcrumbItem>
          <BreadcrumbLink as={Link} to="/sites/edit">
            Edit
          </BreadcrumbLink>
        </BreadcrumbItem>
      </Breadcrumb>
      <Stack mt={4} direction={{ base: 'column', lg: 'row' }}>
        <Box w={'100%'}>
          {/* TODO: #17  Update Skeleton view to match the card structure of the edit card */}
          {!showLoadingView ? (
            <Skeleton height={'500px'} width={'100%'} />
          ) : (
            <MultiStepForm activeStep={step}>
              <Step label="Basic Details">
                <BasicDetails isEdit nextClicked={nextClicked} />
              </Step>
              <Step label="Hero Section">
                <HeroSection
                  isEdit
                  prevClicked={prevClicked}
                  nextClicked={nextClicked}
                />
              </Step>
              <Step label="About Us">
                <AboutUs
                  isEdit
                  prevClicked={prevClicked}
                  nextClicked={nextClicked}
                />
              </Step>
              <Step label="About Service">
                <AboutService
                  isEdit
                  prevClicked={prevClicked}
                  nextClicked={nextClicked}
                />
              </Step>
              <Step label="Gallery">
                <Gallery
                  isEdit
                  prevClicked={prevClicked}
                  nextClicked={nextClicked}
                />
              </Step>
              <Step label="Contact Us">
                <ContactUs
                  isEdit
                  prevClicked={prevClicked}
                  nextClicked={nextClicked}
                />
              </Step>
              <Step label="Social Links">
                <SocialLinks
                  isEdit
                  prevClicked={prevClicked}
                  nextClicked={nextClicked}
                />
              </Step>
            </MultiStepForm>
          )}
        </Box>
      </Stack>
    </>
  );
}

export default EditSite;
